import { Select, composeClasses, PillButton } from '@wiggot/web-components'
import { ICustomSelect } from '@/interfaces'

export const CustomSelect = ({
  isOpen,
  setIsOpen,
  onClose,
  value,
  options,
  optionSelected,
  onSelectOption,
  placeholder,
  classNameContainer,
  withPillButton,
  ...props
}: ICustomSelect) => {
  return (
    <Select
      placeholder={placeholder}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={onClose}
      className={`w-full mt-2 ${classNameContainer}`}
      classNameTrigger="!h-[52px] h-select-custom"
      value={value}
      classNameContainer="w-full max-w-[350px] min-h-[100px] max-h-[150px] overflow-y-auto z-2"
      isResponsive={true}
      customTriggerButton={
        withPillButton && (
          <PillButton
            className="w-full"
            isActive={isOpen}
            rightIcon={
              <span translate="no" className="material-symbols-outlined">
                {isOpen ? 'expand_less' : 'expand_more'}
              </span>
            }
          >
            {value ?? placeholder}
          </PillButton>
        )
      }
      {...props}
    >
      <div className="w-full flex flex-col px-4 gap-2 items-start justify-center">
        {options?.map((option: any) => (
          <button
            key={option.value}
            type="button"
            className={composeClasses(
              option.value === optionSelected?.value && 'font-bold',
              'max-w-[200px] w-full text-left hover:font-semibold active:font-bold'
            )}
            onClick={(event) => {
              event.stopPropagation()
              onSelectOption(option)
              onClose()
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </Select>
  )
}
